// import React, { useState } from 'react';
// import { Link } from "react-router";

// const Header = () => {
//     const [isOpen, setIsOpen] = useState(false);

//     const toggleNavbar = () => {
//         setIsOpen(!isOpen);
//     };

//     return (
//         <nav className="bg-white border-b-2 shadow-md sticky top-0 z-50">
//             <div className="max-w-full py-6 mx-auto px-4 sm:px-6 lg:px-8">
//                 <div className="flex items-center justify-between h-16">
//                     {/* Brand Logo */}
//                     <div className="flex items-center">
//                         <Link to='/'>
//                             <img
//                                 src="/assets/img/logo/logo1.png"
//                                 className="w-16"
//                                 alt="logo"
//                             />
//                         </Link>
//                     </div>

//                     {/* Toggle Button (Mobile Only) */}
//                     <div className="flex md:hidden">
//                         <button
//                             onClick={toggleNavbar}
//                             type="button"
//                             className="text-gray-800 focus:outline-none"
//                         >
//                             <svg
//                                 className="h-6 w-6"
//                                 xmlns="http://www.w3.org/2000/svg"
//                                 fill="none"
//                                 viewBox="0 0 24 24"
//                                 stroke="currentColor"
//                             >
//                                 {isOpen ? (
//                                     <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth="2"
//                                         d="M6 18L18 6M6 6l12 12"
//                                     />
//                                 ) : (
//                                     <path
//                                         strokeLinecap="round"
//                                         strokeLinejoin="round"
//                                         strokeWidth="2"
//                                         d="M4 6h16M4 12h16M4 18h16"
//                                     />
//                                 )}
//                             </svg>
//                         </button>
//                     </div>

//                     {/* Navbar Links */}
//                     <div className="hidden md:flex md:items-center md:space-x-4">
//                         <Link to="/" className="text-h-color hover:text-gray-300 px-3 py-2">
//                             Home
//                         </Link>
//                         <Link to="/about" className="text-h-color hover:text-gray-300 px-3 py-2">
//                             About
//                         </Link>
                        
//                     </div>
//                 </div>
//             </div>

//             {/* Mobile Menu (Dropdown) */}
//             {isOpen && (
//                 <div className="md:hidden bg-gray-100">
//                     <Link
//                         to="/"
//                         className="block text-h-color hover:text-black px-4 py-2"
//                     >
//                         Home
//                     </Link>
//                     <Link
//                         to="/about"
//                         className="block text-h-color hover:text-black px-4 py-2"
//                     >
//                         About
//                     </Link>
                    
//                 </div>
//             )}
//         </nav>
//     );
// };

// export default Header;
import React, { useState } from "react";
import { Link } from "react-router";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNavbar = () => {
    setIsOpen(!isOpen);
  };

  return (
    <nav className="bg-white sticky top-0 z-50">
      <div className="container mx-auto flex items-center justify-between h-20 px-5 sm:px-8 lg:px-10">
        {/* Brand Logo */}
        <div className="flex items-center">
          <Link to="/">
            <img
              src="/assets/img/logo/logo2.jpg"
              className="w-12 sm:w-14 lg:w-16"
              alt="logo"
            /> 
          </Link>
        <div className="justify-items-center">
        <h1 className="ml-20">User experience designer</h1>
        </div>
        </div>

        {/* Toggle Button (Mobile Only) */}
        <div className="flex md:hidden">
          <button
            onClick={toggleNavbar}
            type="button"
            className="text-gray-800 focus:outline-none"
          >
            <svg
              className="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              {isOpen ? (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              ) : (
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              )}
            </svg>
          </button>
        </div>

        {/* Navbar Links (Desktop) */}
        <div className="hidden md:flex md:items-center md:space-x-6 ">
          <Link to="/" className="text-gray-800 hover:text-gray-500 text-sm lg:text-base px-3 py-2">
            Home
          </Link>
          <Link to="/about" className="text-gray-800 hover:text-gray-500 text-sm lg:text-base px-3 py-2">
            About
          </Link>
          
        </div>
      </div>

      {/* Mobile Menu (Dropdown) */}
      {isOpen && (
        <div className="md:hidden bg-gray-100">
          <Link to="/" className="block text-gray-800 hover:text-black text-sm px-4 py-2">
            Home
          </Link>
          <Link to="/about" className="block text-gray-800 hover:text-black text-sm px-4 py-2">
            About
          </Link>
          <Link to="/carecircle" className="block text-gray-800 hover:text-black text-sm px-4 py-2">
          CareCircle
          </Link>
          <Link to="/pulsefit" className="block text-gray-800 hover:text-black text-sm px-4 py-2">
          PulseFit
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Header;
